<button type="button"
  [className]="'btn btn-secondary'"
  ngbTooltip="{{'submission.workflow.tasks.claimed.return_help' | translate}}"
  [dsBtnDisabled]="processing$ | async"
  (click)="submitTask()">
  @if (processing$ | async) {
    <span><i class='fas fa-circle-notch fa-spin'></i> {{'submission.workflow.tasks.generic.processing' | translate}}</span>
  }
  @if ((processing$ | async) !== true) {
    <span><i class="fa fa-undo"></i> {{'submission.workflow.tasks.claimed.return' | translate}}</span>
  }
</button>
